import { render, staticRenderFns } from "./OccurrencesStackedChart.vue?vue&type=template&id=2dde5d3c&"
import script from "./OccurrencesStackedChart.vue?vue&type=script&lang=js&"
export * from "./OccurrencesStackedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports